// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1671 ? "e3c073b4" : chunkId) + "." + {"1671":"fa7ee6db079a2996","7796":"de6bf3d4de7b2b0c"}[chunkId] + ".js";
};